import { Check } from "lucide-react";
import { HeroLeadForm } from "./HeroLeadForm";
import { BOOKING_URL } from "./Layout";
import { practiceLeadPlans } from "@/data/practice-lead-plans";

export function PracticeLeadPlan({ slug }: { slug: string }) {
  const plan = practiceLeadPlans[slug];
  if (!plan) return null;
  return (
    <section id="free-plan" className="scroll-mt-24 bg-hero-gradient text-primary-foreground">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-6 sm:py-20">
        <HeroLeadForm headingLevel="h2" layout="split" lazy
          eyebrow="FREE GROWTH PLAN"
          heading={`Get your free ${plan.practice} SEO plan.`}
          intro="Custom keyword and case forecast for your firm, delivered in 24 hours."
          formFooter={<p className="mt-6 text-center text-xs text-primary-foreground/60">Prefer to talk first? <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="text-gold underline underline-offset-4 transition hover:text-primary-foreground">Book a strategy call</a></p>}
          sideContent={<>
            <p className="mt-7 text-sm font-bold text-primary-foreground">What we'll look at for your firm:</p>
            <ul className="mt-4 space-y-4 text-sm leading-relaxed text-primary-foreground/80">
              {plan.bullets.map((item) => <li key={item} className="flex items-start gap-3"><Check aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-gold" /><span className="min-w-0">{item}</span></li>)}
            </ul>
          </>}
        />
      </div>
    </section>
  );
}